import React, { useEffect, useState } from 'react';
import { staticsUrl } from '../../config';

function Concert(props) {
  const { concertUrl, concertOggUrl } = props.exerciseProps.exercise;
  const { media, finishExercise, action, startStats, type } = props.exerciseProps;
  const [finishPlayed, setFinishPlayed] = useState(false);
  let videoRef = React.createRef();

  const onVideoEnd = () => {
    finishExercise();
    if (!finishPlayed) {
      media.finish();
      setFinishPlayed(true);
    }
  }

  useEffect(() => {
    startStats(type);
    videoRef.current.play();
    videoRef.current.addEventListener("ended", onVideoEnd);
    videoRef.current.addEventListener("timeupdate", action);
    // eslint-disable-next-line
  }, []);



  return (
    <>
    <div />
    <video controls width="1448" height="560" style={{width: '100%'}} ref={videoRef}>
      <source src={staticsUrl + concertUrl} type="video/mp4" />
      <source src={staticsUrl + concertOggUrl} type="video/ogg" />
      Twoja przeglądarka nie wspiera HTML5 video.
    </video>
    <div />
    </>
  );
}

export default Concert;